module.exports = __webpack_public_path__ + "static/media/Images.050c5767.png";